import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import SharedProviders_0_0 from './extensions/order-export/providers';


@NgModule({
    imports: [CommonModule, ],
    providers: [...SharedProviders_0_0],
})
export class SharedExtensionsModule {}
